export default {
    ticketTransfers: state => state.ticketTransfers,
}
